import React, { createContext, useContext } from "react";
import { Box, Container } from "@mui/material";

const CenteredLayoutContext = createContext<boolean>(false);

interface CustomProps {
  children: React.ReactNode;
}

const CenteredAuthenticatedLayout = (props: CustomProps) => {
  const isAlreadyWrapped = useContext(CenteredLayoutContext);

  if (isAlreadyWrapped) {
    return <>{props.children}</>;
  }

  return (
    <CenteredLayoutContext.Provider value={true}>
      {/*
        A `div`, not a `main`: `App` already wraps every protected route in
        `<main id="main-content">`, so this rendered a second, nested main
        landmark — invalid, and it leaves screen-reader users with two "main"
        entries to choose between (WCAG 1.3.1).
      */}
      <Box
        component="div"
        sx={{
          flexGrow: 1,
          mt: { xs: 2, sm: 4, md: 5, lg: 6, xl: 6 },
          pb: 6,
        }}
      >
        <Container maxWidth="xl">{props.children}</Container>
      </Box>
    </CenteredLayoutContext.Provider>
  );
};

export default CenteredAuthenticatedLayout;
